import { FC } from "react";
import { IRenderFormField } from "src/@types/form";

export enum LegalForm {
  indEnt = "фізична-особа-підприємець", // individual entrepreneur or "ФОП"
  legEnt = "юридична-особа", // legal entity or "ЮО"
}

export enum CalculatorField {
  legalForm = "legal_form",
  taxationSystem = "taxation_system",
  singleTaxGroup = "single_tax_group",
  hiredWorkers = "hired_workers",
  workersCount = "workers_count",
  vatPayer = "vat_payer",
  exciseTaxPayer = "excise_tax_payer",
}

export type CalculatorValues = {
  [CalculatorField.legalForm]: LegalForm;
  [CalculatorField.taxationSystem]: string;
  [CalculatorField.vatPayer]: boolean;
  [CalculatorField.singleTaxGroup]: string;
  [CalculatorField.hiredWorkers]: boolean;
  [CalculatorField.workersCount]: number;
  [CalculatorField.exciseTaxPayer]: boolean;
};

export interface ICalculatorStepProps {
  id: string;
  title: string;
  titleClassName?: string;
  responsibleFields: CalculatorField[];
  fields: IRenderFormField[];
  className?: string;
  withAnimation?: boolean;
}

export interface IRenderCalculatorStep extends ICalculatorStepProps {
  step: FC<ICalculatorStepProps>;
}
